import { GridColDef } from "@mui/x-data-grid";

export const columnasDetalleVenta: GridColDef[] = [
  { field: "producto", headerName: "Producto", flex: 1, minWidth: 200 },
  { field: "cantidad", headerName: "Cantidad", width: 110 },
  { field: "cantidadBase", headerName: "Unidades base", width: 130 },
  { field: "precioUnitario", headerName: "Precio unitario", width: 130 },
  { field: "precio", headerName: "Total", width: 130 },
  { field: "forma", headerName: "Forma", width: 160 },
  { field: "cantidadForma", headerName: "Cant. forma", width: 120 },
  { field: "unidadesPorForma", headerName: "Unidades/forma", width: 130 },
];

export const columnasDetalleCompra = (money: (value: unknown) => string): GridColDef[] => [
  { field: "producto", headerName: "Producto", flex: 1, minWidth: 200 },
  { field: "cantidad", headerName: "Cantidad", width: 110 },
  { field: "cantidadBase", headerName: "Unidades base", width: 130 },
  { field: "unitario", headerName: "Costo unitario", width: 130, valueFormatter: (value) => money(value) },
  { field: "total", headerName: "Total", width: 130, valueFormatter: (value) => money(value) },
  { field: "forma", headerName: "Forma", width: 160 },
  { field: "cantidadForma", headerName: "Cant. forma", width: 120 },
  { field: "unidadesPorForma", headerName: "Unidades/forma", width: 130 },
  { field: "costoPorForma", headerName: "Costo forma", width: 130, valueFormatter: (value) => money(value) },
];
